import { gql } from "@apollo/client";

export const GET_DIAGNOSTICOS_CIE_ITEMS = gql`
  query AllDiagnosticoCIEItems(
    $skip: Int,
    $take: Int,
    $where: t_DiagnosticoItemFilterInput,
    $order: [t_DiagnosticoItemSortInput!]
    ) {
    allDiagnosticoCIEItems(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items{
        cod_DiagnosticoCIEItem
        descripcion
        cod_DiagnosticoCIE
        cod_DiagnosticoCIENavigation{
          descripcion
        }
      }
    }
}`;